import { ShapeTypeProps } from '.'

const HalfCircle = ({ color, ...props }: ShapeTypeProps) => {
  return (
    <svg width="204" height="132" viewBox="0 0 204 132" fill="none" {...props}>
      <path
        d="M131 0.54982L0 0.549797L-2.29048e-05 131.55C-3.55404e-05 203.817 58.6115 262.55 131 262.55C203.267 262.55 262 203.938 262 131.55C261.879 59.1614 203.268 0.549833 131 0.54982Z"
        fill={color}
      />
    </svg>
  )
}
export { HalfCircle }
